export const VUEX_ASSETS_FETCH = 'VUEX_ASSETS_FETCH'
export const VUEX_ASSETS_FETCH_SUCCESS = 'VUEX_ASSETS_FETCH_SUCCESS'
export const VUEX_ASSETS_FETCH_FAILURE = 'VUEX_ASSETS_FETCH_FAILURE'

export const VUEX_ASSETS_STATE_UPDATE = 'VUEX_ASSETS_STATE_UPDATE'

export const VUEX_ASSETS_CLEAR = 'VUEX_ASSETS_CLEAR'
